import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-verified",
  "use": "icon-verified-usage",
  "viewBox": "0 0 23.87 23.74",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23.87 23.74\" id=\"icon-verified\">\r\n  <title>verified</title>\r\n  <g>\r\n    <path d=\"M11.93,21.14l-2.49,2.6L8.22,20.35,4.88,21.71l.26-3.59L1.54,18l1.7-3.18L0,13.25,2.85,11,.52,8.29,4,7.43,3,4l3.55.64L7.05,1l3,2L11.93,0l1.9,3.06,3-2,.49,3.57L20.85,4l-1,3.46,3.5.86L21,11l2.84,2.21-3.24,1.57L22.33,18l-3.6.11L19,21.71l-3.34-1.36-1.22,3.39Z\" fill=\"#48c2c5\" />\r\n    <path d=\"M11,13.42l3.61-5.36,1.85,1.25L11.59,16.5,7.43,13.76l1.22-1.87Z\" fill=\"#fff\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/verified.svg
// module id = 313
// module chunks = 0 1